import { flowwise } from "../../../static/img/home";

export const PAYMENTS_MENU_DATA = {
  mainmenu: "Payments",
  isMenuVisibleByDefault: true,
  showDefaultSubMenu: true,
  options: [
    {
      pageId: 0,
      label: "Payment Gateway",
      description: "Collect Payments on your website/app",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/paymentGateway.svg",
      url: "/payment-gateway-india/",
      stylingClass: "mt-[5px]",
    },
    {
      pageId: 1,
      label: "Payment Links",
      description: "Collect payments with simple, shareable links",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/pgPaymentLinks.svg",
      url: "/payment-links/",
      stylingClass: "mt-[5px]",
    },
    {
      pageId: 2,
      label: "Payment Pages",
      description: "Collect payments with custom Payment Pages",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/pgPaymentPages.svg",
      url: "/payment-pages/",
      stylingClass: "mt-[5px]",
    },
    {
      pageId: 3,
      label: "International Payments",
      description: "Accept International payments with ease",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/internationalPayments.svg",
      url: "/cross-border-payment-solutions/",
      stylingClass: "mt-[5px]",
    },
    {
      pageId: 4,
      label: "Payouts",
      description: "Send money instantly to any bank, UPI, card or wallet",
      iconSrc: "https://cashfreelogo.cashfree.com/website/navbar/payouts.svg",
      url: "/payouts/",
      isOptionVisibleByDefault: true,
      stylingClass: "mt-[5px]",
    },
  ],
  subOptions: [
    {
      pageId: 0.1,
      label: "Shopify",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/landings/shopify-payment-gateway-india/ShopifyPlugin.svg",
      url: "/shopify-payment-gateway-india/",
      isSubOption: true,
    },
    {
      pageId: 0.2,
      label: "Customer Stories",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/payment-links.svg",
      url: "/case-study/",
      isSubOption: true,
    },
    {
      pageId: 0.3,
      label: "Flowwise",
      iconSrc: flowwise,
      url: "https://flowwise.com/",
      isSubOption: true,
    },
  ],
};

export const ONBOARDING_DATA = {
  mainmenu: "Identity & Risk Solutions",
  showDefaultSubMenu: true,
  options: [
    {
      pageId: 0,
      label: "Secure ID",
      description:
        "Automate KYC with our onboarding and fraud monitoring platform",
      iconSrc: "https://cashfreelogo.cashfree.com/website/navbar/kycstudio.svg",
      url: "/kyc-verification/",
      stylingClass: "mt-[5px]",
    },
    {
      pageId: 1,
      label: "KYC Studio",
      description: "No-code Journey builder for complete KYC onboarding",
      iconSrc: `https://cashfreelogo.cashfree.com/website/landings/homepage/verifyIdentity.svg`,
      url: "/kyc-studio/",
      stylingClass: "mt-[5px]",
    },

    {
      pageId: 2,
      label: "RiskShield",
      description: "Prevent fraud using ML-based anomaly detection",
      iconSrc: "https://cashfreelogo.cashfree.com/website/navbar/trust.svg",
      url: "/risk-shield-payment-gateway/",
      stylingClass: "mt-[5px]",
    },
  ],
  subOptions: [],
};

export const DEVELOPERS_DATA = {
  mainmenu: "Developers",
  isMenuVisibleByDefault: true,
  showDefaultSubMenu: true,
  options: [
    {
      pageId: 0,
      label: "Payment APIs",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/paymentAPIs.svg",
      url: "https://www.cashfree.com/docs/payments/overview",
      isOptionVisibleByDefault: true,
    },
    {
      pageId: 1,
      label: "Secure ID APIs",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/identityAPIs.svg",
      url: "https://www.cashfree.com/docs/secure-id/introduction",
      isOptionVisibleByDefault: true,
    },
    {
      pageId: 2,
      label: "Payouts APIs",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/payoutsAPIs.svg",
      url: "https://www.cashfree.com/docs/payouts/payouts/introduction",
      isOptionVisibleByDefault: true,
    },
  ],
  subOptions: [
    {
      pageId: 0.1,
      label: "Dev Studio",
      iconSrc: "https://cashfreelogo.cashfree.com/assets_images/pg/cflabs.svg",
      url: "https://www.cashfree.com/devstudio",
      isSubOption: true,
    },
  ],
};

export const PARTNERS_DATA = {
  mainmenu: "Partner with us",
  showDefaultSubMenu: true,
  options: [
    {
      pageId: 0,
      label: "Affiliate Program",
      description: "Refer Cashfree Payments and earn commissions",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/affiliateProgram.svg",
      url: "/affiliate-program/",
      stylingClass: "mt-[5px]",
    },
    {
      pageId: 1,
      label: "Embedded payments",
      description:
        "Offer a native payments experience by using our powerful APIs",
      iconSrc:
        "https://cashfreelogo.cashfree.com/website/navbar/embeddedPartners.svg",
      url: "/embedded-payments/",
      stylingClass: "mt-[5px]",
    },
  ],
  subOptions: [],
};

export const SUPPORT_DATA = {
  mainmenu: "Support",
  isMenuVisibleByDefault: true,
  showDefaultSubMenu: true,
  options: [
    {
      pageId: 0,
      label: "Resolve Issue",
      iconSrc: "https://cashfreelogo.cashfree.com/website/navbar/help.svg",
      url: "/support/",
      isOptionVisibleByDefault: true,
    },
    {
      pageId: 1,
      label: "Blog",
      iconSrc: "https://cashfreelogo.cashfree.com/website/navbar/blog.svg",
      url: "https://www.cashfree.com/blog/",
    },
    {
      pageId: 2,
      label: "Newsroom",
      iconSrc: "https://cashfreelogo.cashfree.com/website/navbar/newsroom.svg",
      url: "/news-room/",
      isOptionVisibleByDefault: true,
    },
  ],
  subOptions: [],
};

export const PRICING_DATA = {
  mainmenu: "Pricing",
  isMenuVisibleByDefault: true,
  options: [
    {
      pageId: 0,
      label: "Pricing",
      url: "/payment-gateway-charges/",
    },
  ],
};

export const MENU_DATA = [
  {
    id: 0,
    ...PAYMENTS_MENU_DATA,
  },
  {
    id: 1,
    ...ONBOARDING_DATA,
  },
  {
    id: 2,
    ...DEVELOPERS_DATA,
  },
  {
    id: 3,
    ...PARTNERS_DATA,
  },
  {
    id: 4,
    ...SUPPORT_DATA,
  },
  {
    id: 5,
    ...PRICING_DATA,
  },
];
